<template>

  <!-- Page Sidebar Ends-->
  <div class="page-body">

    <PageTitle title="Dashboard" btn="Add" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row size-column">
        <div class="col-xxl-12 box-col-12">
          <div class="row">
             <div class="col-xl-3 col-sm-4">
              <router-link to="gatepass?q=today">
                <div class="card o-hidden small-widget">
                  <div class="card-body total-project border-b-primary border-2"><span
                      class="f-light f-w-500 f-14">Total Visitor <i class="icofont icofont-users"></i></span>
                    <div class="project-details">
                      <div class="project-counter">
                         <h2 class="f-w-600">{{ today_gatepasses }}</h2>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-xl-3 col-sm-4">
              <router-link to="gatepass?q=expected">
                <div class="card o-hidden small-widget ">
                  <div class="card-body total-project border-b-primary border-2 bg-warning-light "><span
                      class="f-light f-w-500 f-14">Expected  <i class="icofont icofont-users"></i></span>
                    <div class="project-details">
                      <div class="project-counter">
                         <h2 class="f-w-600">{{ today_gatepasses_expected }}</h2>
                      </div> 
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-xl-3 col-sm-4">
              <router-link to="gatepass?q=checkin">
                <div class="card o-hidden small-widget">
                  <div class="card-body total-Progress border-b-warning border-2"> <span
                      class="f-light f-w-500 f-14">Checked In    <i class="icofont icofont-arrow-left"></i></span>
                    <div class="project-details">
                      <div class="project-counter">
                        <h2 class="f-w-600">{{ today_gatepasses_active }}</h2>
                      </div>
                     
                    </div>

                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-xl-3 col-sm-4">
              <router-link to="gatepass?q=checkout">
                <div class="card o-hidden small-widget">
                  <div class="card-body total-Complete border-b-secondary border-2"><span
                      class="f-light f-w-500 f-14">Checked Out  <i class="icofont icofont-arrow-right"></i></span>
                    <div class="project-details">
                      <div class="project-counter">
                        <h2 class="f-w-600">{{ today_gatepasses_done }}</h2>
                      </div> 
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            
            <!--WORK PERMIT-->
            
            
             <div class="col-xl-4 col-sm-4">
              <router-link to="gatepass?q=wp_today">
                <div class="card o-hidden small-widget">
                  <div class="card-body total-project border-b-primary border-2"><span
                      class="f-light f-w-500 f-14">Total Workpermit <i class="icofont icofont-users"></i></span>
                    <div class="project-details">
                      <div class="project-counter">
                         <h2 class="f-w-600">{{ wp_today_gatepasses }}</h2>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
             <div class="col-xl-4 col-sm-4">
              <router-link to="gatepass?q=wp_checkin">
                <div class="card o-hidden small-widget">
                  <div class="card-body total-Progress border-b-warning border-2"> <span
                      class="f-light f-w-500 f-14">Checked In Workpermit   <i class="icofont icofont-arrow-left"></i></span>
                    <div class="project-details">
                      <div class="project-counter">
                        <h2 class="f-w-600">{{ wp_today_gatepasses_active }}</h2>
                      </div>
                     
                    </div>

                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-xl-4 col-sm-4">
              <router-link to="gatepass?q=wp_checkout">
                <div class="card o-hidden small-widget">
                  <div class="card-body total-Complete border-b-secondary border-2"><span
                      class="f-light f-w-500 f-14">Checked Out Workpermit <i class="icofont icofont-arrow-right"></i></span>
                    <div class="project-details">
                      <div class="project-counter">
                        <h2 class="f-w-600">{{ wp_today_gatepasses_done }}</h2>
                      </div> 
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <!--<div class="col-xl-3 col-sm-4">-->
            <!--  <router-link to="vehicalrequest">-->
            <!--    <div class="card o-hidden small-widget">-->
            <!--      <div class="card-body total-upcoming"><span class="f-light f-w-500 f-14">Today Vehicle-Req</span>-->
            <!--        <div class="project-details">-->
            <!--          <div class="project-counter">-->
            <!--            <h2 class="f-w-600">{{ today_veh_req }}</h2>-->
            <!--          </div>-->
            <!--          <div class="product-sub bg-light-light">-->

            <!--          </div>-->
            <!--        </div>-->
            <!--      </div>-->
            <!--    </div>-->
            <!--  </router-link>-->
            <!--</div>-->
          </div>
        </div>
        <!--<div class="col-xxl-9 box-col-12 card">-->
        <!-- <div class="card-header">-->
        <!--    <h2 class="card-title">Department Meeting Schedule</h2>-->
        <!-- </div>-->
        <!--  <div class="card-body row">-->

        <!--    <div class="col-12 col-md-4" v-for="(item, index)  in all_reservations" :key="item.gatepassid">-->


        <!--      <div class="accordion-item">-->
        <!--      <h2 class="accordion-header" :id="index+'_acc'">-->
        <!--        <button class="accordion-button collapsed accordion-light-primary txt-primary" type="button"-->
        <!--          data-bs-toggle="collapse" :data-bs-target="'#'+'collapse_'+index" aria-expanded="false"-->
        <!--          aria-controls="collapseOne"> {{ item.date }}<i class="svg-color"-->
        <!--            data-feather="chevron-down"></i></button>-->
        <!--      </h2>-->
        <!--      <div class="accordion-collapse collapse " :id="'collapse_'+index" :aria-labelledby="index+'_acc'"-->
        <!--        data-bs-parent="#simpleaccordion">-->
        <!--        <div class="accordion-body">-->
        <!--          <div v-for="(row, index)  in item.schedule" :class="(row.status == 2) ? 'meet_success' : 'meet_pending'">-->
        <!--          <div><b>{{ index + 1 }}. {{ row.emp_name }}</b> <span class="badge badge-info">{{ row.shedule_time }}</span>-->
        <!--          </div>-->
        <!--          <div>Purpose : {{ row.purpose }} <span class="badge badge-warning">{{ row.room_details }}</span></div>-->
        <!--          <hr>-->
        <!--        </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <!--    </div>-->


             
        <!--    </div>-->

        <!--  </div>-->
        <!--</div>-->
      </div>
    </div>
    <!-- Container-fluid Ends-->
   <div class="container-fluid">
    <!--<div class="col-md-12  col-12 row" v-if="emp.emprole==1 || emp.empdept==sd">-->
    <div class="col-md-12  col-12 row" >
        <div class="card card-body col-md-6  col-12" >
          <canvas id="visitorChart"   ></canvas>    
        </div>
        <div class="card card-body col-md-6  col-12" >
          <canvas id="visitorChartDept"   ></canvas>    
        </div>
         <div class="card card-body col-md-6  col-12" >
          <canvas id="visitorChartHrs"   ></canvas>    
        </div>
         <div class="card card-body col-md-6  col-12" >
                <div class="live-feed">
                      <h6>Live Check-in/Checkout Feed</h6>
                      <ul style="line-height:30px;" class="mt-3">
                        <li v-for="record in liveFeed" :key="record.id">
                          
                          <small  v-if="record.check_out"><span  class="badge bg-danger">OUT</span>  {{ record.name }} -Checked Out at {{ record.check_out }}</small>
                          <small   v-else><span  class="badge bg-success">IN</span>{{ record.name }} -Checked In at {{ record.check_in }}</small>
                        </li>
                      </ul>
                    </div>
        </div>
    </div>
    </div>
 
    <!--<div class="card card-body">-->
      <!-- Calendar header to show "2024 Sep" and toggle the view -->
    <!--  <div class="calendar-header">-->
        <!-- Clicking the button toggles between year view and month view -->
    <!--    <button class="badge-primary text-white" @click="showYearView = !showYearView">{{ currentYear }} {{ currentMonthName }}</button>-->
    <!--  </div>-->
    
      <!-- Month view (shows the current month only if not in year view) -->
    <!--  <div v-if="!showYearView" class="calendar-month-view">-->
    <!--    <table>-->
    <!--      <thead>-->
    <!--        <tr>-->
    <!--          <th v-for="day in daysOfWeek" :key="day">{{ day }}</th>-->
    <!--        </tr>-->
    <!--      </thead>-->
    <!--      <tbody>-->
    <!--        <tr v-for="week in calendarDays" :key="week[0].date">-->
    <!--          <td v-for="day in week" :key="day.date" -->
    <!--              :class="{ 'empty-day': !day.isInMonth, -->
    <!--                        'today': isToday(day), -->
    <!--                        'selected': isSelected(day), -->
    <!--                        'has-reservation': hasReservation(day) }"-->
    <!--              @click="selectDay(day)">-->
    <!--            {{ day.isInMonth ? day.date.getDate() : '' }}-->
                <!-- Reservation Details -->
    <!--            <div class="card-body row" v-if="isSelected(day)">-->
    <!--              <div class="col-12 col-md-4" v-for="(item, index) in selectedReservations" :key="item.gatepassid">-->
    <!--                <div class="accordion-item">-->
    <!--                  <h2 class="accordion-header" :id="'accordion-header-' + index">-->
                        <!-- Add dynamic class based on selected date -->
    <!--                    <button-->
    <!--                      :class="{-->
    <!--                        'accordion-button': true,-->
    <!--                        'collapsed': selectedDay !== item.date,-->
    <!--                        'accordion-light-primary txt-primary': true,-->
    <!--                        'highlighted': selectedDay === item.date-->
    <!--                      }"-->
    <!--                      type="button"-->
    <!--                      data-bs-toggle="collapse"-->
    <!--                      :data-bs-target="'#collapse_' + index"-->
    <!--                      aria-expanded="false"-->
    <!--                      :aria-controls="'collapse_' + index"-->
    <!--                      @click="toggleCollapse(item.date, index)"-->
    <!--                    >-->
    <!--                      {{ day.date.getDate() }}-->
    <!--                      <i class="svg-color" data-feather="chevron-down"></i>-->
    <!--                    </button>-->
    <!--                  </h2>-->
    <!--                  <div-->
    <!--                    class="accordion-collapse collapse"-->
    <!--                    :id="'collapse_' + index"-->
    <!--                    :aria-labelledby="'accordion-header-' + index"-->
    <!--                    data-bs-parent="#simpleaccordion"-->
    <!--                  >-->
    <!--                    <div class="accordion-body">-->
    <!--                      <div-->
    <!--                        v-for="(row, i) in item.schedule"-->
    <!--                        :key="i"-->
    <!--                        :class="row.status == 2 ? 'meet_success' : 'meet_pending'"-->
    <!--                      >-->
    <!--                        <div>-->
    <!--                          <b>{{ i + 1 }}. {{ row.emp_name }}</b>-->
    <!--                          <span class="badge badge-info">{{ row.shedule_time }}</span>-->
    <!--                        </div>-->
    <!--                        <div>-->
    <!--                          Purpose: {{ row.purpose }}-->
    <!--                          <span class="badge badge-warning">{{ row.room_details }}</span>-->
    <!--                        </div>-->
    <!--                        <hr />-->
    <!--                      </div>-->
    <!--                    </div>-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </td>-->
    <!--        </tr>-->
    <!--      </tbody>-->
    <!--    </table>-->
    <!--  </div>-->
    
      <!-- Year view (shows all 12 months) -->
    <!--  <div v-if="showYearView" class="calendar-year-view">-->
    <!--    <div v-for="(month, index) in months" :key="index" class="month-view">-->
    <!--      <div class="month-name">{{ month }}</div>-->
    <!--      <table @click="changeMonth(index)">-->
    <!--        <thead>-->
    <!--          <tr>-->
    <!--            <th v-for="day in daysOfWeek" :key="day">{{ day }}</th>-->
    <!--          </tr>-->
    <!--        </thead>-->
    <!--        <tbody>-->
    <!--          <tr v-for="week in generateCalendar(currentYear, index)" :key="week[0].date">-->
    <!--            <td v-for="day in week" :key="day.date" :class="{ 'empty-day': !day.isInMonth,'has-reservation': hasReservation(day) }">-->
    <!--              {{ day.isInMonth ? day.date.getDate() : '' }}-->
    <!--            </td>-->
    <!--          </tr>-->
    <!--        </tbody>-->
    <!--      </table>-->
    <!--    </div>-->
    <!--  </div>-->
    <!--</div>-->
    
     
  </div>



</template>
<style scoped>
.card .card-body{
        padding: 10px 10px;
}
.meet_success{
  background: #97ff8d;
  padding: 5px;
}.meet_pending{
  background: #a4a4a4;
  padding: 5px;
  font-size: smaller;
}
.accordion-item{
  padding: 5px;
}


.calendar-header {
  font-size: 20px;
  text-align: center;
  margin-bottom: 10px;
}

.calendar-month-view table {
  width: 100%;
  border-collapse: collapse;
}

.calendar-month-view th,
.calendar-month-view td {
  padding: 10px;
  text-align: center;
  border: 1px solid #ddd;
}

.empty-day {
  color: #ccc;
}
.badge-primary{
  display: block;
}
.has-reservation {
    background-color: #4caf50; /* Green highlight for dates with reservations */
    color: white;
  }
.today {
  background-color: #ffeb3b; /* Highlight today with yellow */
  color: #000;
  font-weight: bold;
}
.highlighted {
    background-color: #007bff;
    color: white;
  }
.selected {
  background-color: #4caf50; /* Highlight the selected day with green */
  color: #fff;
  font-weight: bold;
}
.calendar-year-view {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Display 3 months per row */
  gap: 20px;
}

.month-view {
  text-align: center;
}

.month-name {
  font-weight: bold;
  margin-bottom: 10px;
}

.month-view table {
  width: 100%;
  border-collapse: collapse;
}

.month-view th,
.month-view td {
  padding: 5px;
  text-align: center;
  border: 1px solid #ddd;
}
  </style>
<script>
import PageTitle from '@/components/PageTitle.vue';
// import axios from 'axios';
import axios from "@/plugins/axios";

export default {
  name: 'HomeView',
  components: {
    PageTitle
  },
  mounted() {
    this.getDashboard();
  },
  data() {
    const currentDate = new Date();
    return {
      emp: [name => '', dept => '', empcode => '', role => ''],
      today_gatepasses: 0,
      today_gatepasses_active: 0,
      today_gatepasses_done: 0,
      today_gatepasses_expected: 0,
      
      wp_today_gatepasses: 0,
      wp_today_gatepasses_active: 0,
      wp_today_gatepasses_done: 0,
      wp_today_gatepasses_expected: 0,
      
      
      
      today_veh_req: 0,
      otp: '',
      all_reservations: [],
      selectedReservations: [],
      currentMonth: currentDate.getMonth(), // Get current month (0-indexed, e.g., 0 = January)
      currentYear: currentDate.getFullYear(), // Get current year
      today: currentDate,
      selectedDay: null, // Track the selected day
      showYearView: false, // Controls if year view is shown
      daysOfWeek: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      months: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug',
        'Sep', 'Oct', 'Nov', 'Dec'
      ],
      chartInstance:null,
      chartInstancedept:null,
      chartInstancehrs:null,
      hourlyData:[],
      liveFeed:[],
      isLiveStarted:false,
      sd:0

    }
  },
  computed: {
    // Get the current month's name based on the currentMonth index
    currentMonthName() {
      return this.months[this.currentMonth];
    },
    // Generate days for the current month
    calendarDays() {
      return this.generateCalendar(this.currentYear, this.currentMonth);
    }
  },
  methods: {
       async fetchLiveFeed() {
        try {
              axios.post('liveFeed' ).then(function (response) { 
                self.liveFeed = response.data.liveFeed;  
            });
        } catch (err) {
          console.error('Error fetching live feed:', err);
        }
      },
    hasReservation(day) {
    // Check if a date in calendar matches any reservation date
    return (!this.all_reservations?[]:this.all_reservations).some(reservation => {
      const reservationDate = new Date(reservation.date);
      return (
        reservationDate.getDate() === day.date.getDate() &&
        reservationDate.getMonth() === day.date.getMonth() &&
        reservationDate.getFullYear() === day.date.getFullYear()
      );
    });
  },
  toggleCollapse(reservationDate, index) {
    const targetId = 'collapse_' + index;
    const target = document.getElementById(targetId);

    if (this.selectedDay && new Date(reservationDate).toDateString() === this.selectedDay.toDateString()) {
      // Toggle the collapse state
      const bsCollapse = new bootstrap.Collapse(target, {
        toggle: true
      });
    } else {
      this.selectDay(new Date(reservationDate)); // If different day, select it
    }
  },
    // Generate the days for the given month and year
    generateCalendar(year, month) {
      const startDay = new Date(year, month, 1).getDay();
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      let calendar = [];
      let week = [];
      let dayCounter = 1;

      // Generate trailing days for the previous month
      for (let i = 0; i < startDay; i++) {
        week.push({ isInMonth: false, date: new Date(year, month, dayCounter++) });
      }

      // Generate current month's days
      for (let i = 1; i <= daysInMonth; i++) {
        week.push({ isInMonth: true, date: new Date(year, month, i) });
        if (week.length === 7) {
          calendar.push(week);
          week = [];
        }
      }

      // Fill remaining week with next month's leading days
      while (week.length < 7) {
        week.push({ isInMonth: false, date: new Date(year, month + 1, dayCounter++) });
      }

      calendar.push(week);
      return calendar;
    },
    isToday(day) {
      // Check if the given day is today's date
      const today = this.today;
      return (
        day.isInMonth &&
        day.date.getDate() === today.getDate() &&
        day.date.getMonth() === today.getMonth() &&
        day.date.getFullYear() === today.getFullYear()
      );
    },
    selectDay(day) {
      // Set the selected day
      if (day.isInMonth) {
        this.selectedDay = day.date;

        // Filter reservations based on the selected date
      const selectedDate = `${this.selectedDay.getFullYear()}-${(this.selectedDay.getMonth() + 1).toString().padStart(2, '0')}-${this.selectedDay.getDate().toString().padStart(2, '0')}`;
      this.selectedReservations = this.all_reservations?.filter(reservation => reservation.date === selectedDate);
      }
    },
    isSelected(day) {
      // Check if the day is the selected day
      return (
        this.selectedDay &&
        day.isInMonth &&
        day.date.getDate() === this.selectedDay.getDate() &&
        day.date.getMonth() === this.selectedDay.getMonth() &&
        day.date.getFullYear() === this.selectedDay.getFullYear()
      );
    },
    changeMonth(monthIndex) {
      this.currentMonth = monthIndex;
      this.showYearView = false;
    },
    getDashboard() {
        
      var self = this;
      

      if (localStorage['token']) {
        axios.post('getDashboard' ).then(function (response) {
          if (response.data.is == 1) {
            self.emp = response.data.emp;
            if(self.emp.emprole==5){
                this.$router.replace({ name: "KitchenDashboard" });
                 return;
            }      
            
            self.today_gatepasses = response.data.today_gatepasses;
            self.today_gatepasses_active = response.data.today_gatepasses_active;
            self.today_gatepasses_done = response.data.today_gatepasses_done;
            self.today_gatepasses_expected = response.data.today_gatepasses_expected;
            
            self.wp_today_gatepasses = response.data.wp_today_gatepasses;
            self.wp_today_gatepasses_active = response.data.wp_today_gatepasses_active;
            self.wp_today_gatepasses_done = response.data.wp_today_gatepasses_done;
            self.wp_today_gatepasses_expected = response.data.wp_today_gatepasses_expected;
            
            
            
            self.today_veh_req = response.data.today_veh_req;
            self.all_reservations = response.data.all_reservations;
            self.liveFeed = response.data.liveFeed; 
            self.sd = response.data.sd; 
            
           
            
            // if(self.emp.emprole==1 ||   self.emp.empdept==self.sd){
                self.loadChart(response.data.chart_data,response.data.deptChartData,response.data.hourlyData);
                // if(!self.isLiveStarted){
                //     self.isLiveStarted=true;
                //     setInterval(self.getDashboard, 10000);
                // }
            // }
            
          } else {
          }
        });
      }else{
          localStorage.removeItem('token');
          self.$swal("Session Expired, Please Login");
          self.$router.push({ name: "login" });
      }
    },
    loadChart(data,deptChartData,hourlyData){
            var self=this;
        
        this.$nextTick(() => {
           const ctx = document.getElementById('visitorChart');
              if (!ctx) {
                  console.error("Chart element not found.");
                  return;
                }
            
                const chartContext = ctx.getContext('2d');
            
                
        if (self.chartInstance) {
          self.chartInstance.destroy();
        }
       
        
        self.chartInstance = new Chart(chartContext, {
          type: 'line',
          data: {
            labels: data.map(d => d.date),
            datasets: [
              {
                label: 'Visitors',
                data: data.map(d => parseInt(d.total_visitors || 0)),
                backgroundColor: 'rgba(54, 162, 235, 0.7)',
                 borderColor: 'rgba(54, 162, 235, 0.7)',
              },
              {
                label: 'Work Permits',
                data: data.map(d => parseInt(d.total_workpermits || 0)),
                backgroundColor: 'rgba(255, 99, 132, 0.7)',
                 borderColor: 'rgba(255, 99, 132, 0.7)',
              }
            ]
          },
          options: {
            responsive: true,
            plugins: {
              title: {
                display: true,
                text: 'Daily Visitors & Work Permits (Last 10 Days)'
              },
              legend: {
                position: 'top'
              }
            },
            scales: {
              x: {
               stacked: false  
              },
              y: {
                stacked: false,
                beginAtZero: true
              }
            }
          }
        });
        
        
        // dept chart data
             const grouped = {};
            
              deptChartData.forEach(row => {
                if (!grouped[row.deptname]) grouped[row.deptname] = [];
                grouped[row.deptname].push({ date: row.date, visitors: row.total_visitors });
              });
            
              const dates = [...new Set(deptChartData.map(r => r.date))];
            
             const datasets = Object.keys(grouped).map((dept, index) => {
              const color = self.getRandomColor(index);
              return {
                label: dept,
                data: dates.map(date => {
                  const match = grouped[dept].find(d => d.date === date);
                  return match ? match.visitors : 0;
                }),
                borderColor: color,
                backgroundColor: color + '55', // translucent fill
                tension: 0.3,
                fill: false, // use true if you want the area under the line filled
                borderWidth: 2
              };
            });
            
              const ctx_dept = document.getElementById('visitorChartDept').getContext('2d');
              if (self.chartInstancedept) self.chartInstancedept.destroy();
            
              self.chartInstancedept = new Chart(ctx_dept, {
                type: 'line',
                data: {
                  labels: dates,
                  datasets: datasets,
                },
                options: {
                  responsive: true,
                  plugins: {
                    title: {
                      display: true,
                      text: 'Visitors per Department (Last 10 Days)'
                    },
                    legend: { position: 'top' },
                  },
                  scales: {
                    x: { stacked: false },
                    y: { stacked: false, beginAtZero: true }
                  }
                }
              });        
        
       
        
           const ctx_hrs = document.getElementById('visitorChartHrs').getContext('2d');
              if (self.chartInstancehrs) self.chartInstancehrs.destroy();
        //peak hours
        self.chartInstancehrs = new Chart(ctx_hrs, {
              type: 'bar',
              data: {
                 labels: hourlyData.map(h => `${h.check_in_hour}:00`), // ['0:00', '1:00', ..., '23:00']
                datasets: [
                  {
                    label: 'Check-ins per Hour (Last 10 Days)',
                    data:  hourlyData.map(d => d.total_checkins)  , // This should be an array of 24 values (0 if no data for that hour)
                    backgroundColor: 'rgba(75, 192, 192, 0.6)',
                     borderRadius: 5,
                  }
                ]
              },
              options: {
                responsive: true,
                plugins: {
                  title: {
                    display: true,
                    text: 'Peak Visitor Hours (Last 10 Days)'
                  },
                  legend: {
                    display: false
                  }
                },
                scales: {
                  y: {
                    beginAtZero: true
                  }
                }
              }
            });
        });
      },
      getRandomColor(index) {
          const colors = [
            'rgba(54, 162, 235, 0.7)',
            'rgba(255, 99, 132, 0.7)',
            'rgba(255, 206, 86, 0.7)',
            'rgba(75, 192, 192, 0.7)',
            'rgba(153, 102, 255, 0.7)',
            'rgba(255, 159, 64, 0.7)',
            'rgba(199, 199, 199, 0.7)',
            'rgba(83, 102, 255, 0.7)',
            'rgba(255, 102, 255, 0.7)',
            'rgba(102, 255, 178, 0.7)'
          ];
          return colors[index % colors.length];
        },
  }
}
</script>
